module.exports = __webpack_public_path__ + "static/images/containers/Construct/images/construct-bg-50.0e317bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/Construct/images/construct-bg-50.jpg
// module id = 3087
// module chunks = 11